import { render, staticRenderFns } from "./InstallApplication.vue?vue&type=template&id=2ffa27f0&"
import script from "./InstallApplication.vue?vue&type=script&lang=ts&"
export * from "./InstallApplication.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports